<script setup>
const steps = [
    {
        title: 'בקשתך התקבלה',
        status: 'completed'
    },
    {
        title: 'בטיפול',
        status: 'progress'
    },
    {
        title: 'השליח יגיע ביום ד’ 14:00-16:00',
        status: ''
    },
    {
        title: 'ההזמנה נמסרה',
        status: ''
    }

]
</script>

<template>
    <div class="tracking-steps">
        <ul>
            <li v-for="(item, index) in steps" :key="index" :class="item.status">
                <img v-if="item.status === 'completed'" :src="`${theme_path.url}/resources/images/ico-check.svg`" alt="">
                <div v-else class="tracking-count">{{  index + 1 }}</div>
                <h5>{{ item.title }}</h5>
            </li>
        </ul>
    </div>
</template>